import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../../src/api-routes";
import apiService from "../../../services/service";
const initialState = {
  generalInformation: null,
  status: "idle",
  error: null,
  reset: false,
};

export const fetchGeneralInformation = createAsyncThunk(
  "generalInformation/fetchGeneralInformation",
  async (arg) => {
    // Support both old signature (id string) and new signature ({ id, skipCache })
    const id = typeof arg === "object" ? arg.id : arg;
    const skipCache = typeof arg === "object" ? arg.skipCache : false;
    const res = await apiService(API_ROUTES.FETCH_ENTITY, "GET", {
      replace: { id },
      skipCache,
    });
    return res;
  },
);

const generalInformationSlice = createSlice({
  name: "generalInformation",
  initialState,
  reducers: {
    resetGeneralInformation: (state) => {
      state.status = "idle";
      state.generalInformation = null;
      state.error = null;
    },
    resetFormDetail: (state, action) => {
      state.reset = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGeneralInformation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchGeneralInformation.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.generalInformation = action.payload;
      })
      .addCase(fetchGeneralInformation.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { resetGeneralInformation, resetFormDetail } =
  generalInformationSlice.actions;

export default generalInformationSlice.reducer;
